import React, { Fragment } from 'react';
import { ANSWER } from 'site-modules/shared/constants/smiley-survey';

export const BUILD_PRICE_SMILEY_SURVEY_CONFIG = {
  question: (
    <Fragment>
      How would you rate your
      <br />
      Build and Price experience?
    </Fragment>
  ),
  creativeId: 'b&p_survey',
  smileyTrackingId: 'build_select_survey',
  textTrackingIdMap: {
    [ANSWER.DISSATISFIED]: 'build_survey_dissat_details',
    [ANSWER.NEUTRAL]: 'build_survey_neutral_details',
    [ANSWER.SATISFIED]: 'build_survey_sat_details',
  },
};
